import { render, staticRenderFns } from "./NewServerIndex.vue?vue&type=template&id=4e336897&scoped=true"
import script from "./NewServerIndex.vue?vue&type=script&lang=js"
export * from "./NewServerIndex.vue?vue&type=script&lang=js"
import style0 from "./NewServerIndex.vue?vue&type=style&index=0&id=4e336897&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e336897",
  null
  
)

export default component.exports